<template>
  <div class="grid grid-cols-1 grid-rows-2 mb-8 bg-white border-r-2 border-app-lime rounded-xl overflow-hidden md:gap-24 md:grid-cols-5 md:grid-rows-1">
    <div class="flex flex-col place-content-center order-2 px-6 py-8 leading-8 md:col-end-4 md:col-start-1 md:order-1 md:px-20">
      <slot />
    </div>
    <div class="order-1 md:col-end-6 md:col-start-4 md:order-2">
      <MoleculePicture :image="image" />
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  image: object
}

defineProps<Props>()
</script>
